import { useMediaQuery } from '@material-ui/core';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { amountAndVatFieldColumn } from './components/amountAndVatFieldColumn';
import { amountFieldColumn } from './components/amountFieldColumn';
import { orderIdFieldColumn } from './components/orderIdFieldColumn';
import { toOrderDetailFieldColumn } from './components/toOrderDetailFieldColumn';
import { transactionTypeFieldColumn } from './components/transactionTypeFieldColumn';
import { transactionTypeMobileFieldColumn } from './components/transactionTypeMobileFieldColumn';
import { vatAmountFieldColumn } from './components/vatAmountFieldColumn';
import { vatRateFieldColumn } from './components/vatRateFieldColumn';

export function TransactionsDataGridFields() {
  const { breakpoints } = useCustomTheme();

  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const defaultTransactionFields = {
    desktop: [
      transactionTypeFieldColumn({ flex: 0.3 }),
      vatRateFieldColumn({ flex: 0.3 }),
      vatAmountFieldColumn({ flex: 0.3 }),
      amountFieldColumn({ flex: 0.3 }),
      orderIdFieldColumn({ flex: 0.45 }),
      toOrderDetailFieldColumn({ flex: 0.15 }),
    ],
    mobile: [transactionTypeMobileFieldColumn({ flex: 0.55 }), amountAndVatFieldColumn({ flex: 0.45 })],
  };

  const DataGridFields = {
    transaction: defaultTransactionFields.desktop,
  };

  const MobileDataGridFields = {
    transaction: defaultTransactionFields.mobile,
  };

  return isDownMd ? MobileDataGridFields.transaction : DataGridFields.transaction;
}
